import { render, staticRenderFns } from "./sub-nav.vue?vue&type=template&id=6a845021&scoped=true&lang=pug&"
import script from "./sub-nav.vue?vue&type=script&lang=coffee&"
export * from "./sub-nav.vue?vue&type=script&lang=coffee&"
import style0 from "./sub-nav.vue?vue&type=style&index=0&id=6a845021&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a845021",
  null
  
)

export default component.exports